import { Component } from 'react';

/**
 * ErrorBoundary — catches render errors in any child subtree.
 * Shows a friendly fallback instead of a blank screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production you'd send this to a logging service
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { fallback } = this.props;
    if (fallback) return fallback;

    return (
      <div style={{
        minHeight: '60vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '48px 24px', textAlign: 'center',
        background: 'var(--bg,#FAF7FD)',
      }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>⚠️</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--ink,#1A1222)', margin: '0 0 8px' }}>
          Something went wrong
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ink-2,#5C5365)', maxWidth: 380, lineHeight: 1.6, margin: '0 0 24px' }}>
          An unexpected error occurred. The page couldn't be displayed.
        </p>
        <button
          onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
          style={{
            padding: '10px 28px', border: 'none', borderRadius: 10,
            background: 'var(--primary,#C81E78)', color: '#fff',
            fontSize: 14, fontWeight: 700, cursor: 'pointer',
          }}
        >
          Reload page
        </button>
        {process.env.NODE_ENV === 'development' && this.state.error && (
          <details style={{ marginTop: 24, textAlign: 'left', maxWidth: 600 }}>
            <summary style={{ fontSize: 12, color: 'var(--ink-3)', cursor: 'pointer' }}>Error details</summary>
            <pre style={{ fontSize: 11, color: 'var(--danger,#E23145)', whiteSpace: 'pre-wrap', marginTop: 8 }}>
              {this.state.error.toString()}
            </pre>
          </details>
        )}
      </div>
    );
  }
}
